import script from "./ModalRecordarPass.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalRecordarPass.vue?vue&type=script&setup=true&lang=ts"

import "./ModalRecordarPass.vue?vue&type=style&index=0&id=54d219b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d219b1"]])

export default __exports__